import { render, staticRenderFns } from "./DefaultContainerNoSidenav.vue?vue&type=template&id=bd50bc80&scoped=true"
import script from "./DefaultContainerNoSidenav.vue?vue&type=script&lang=js"
export * from "./DefaultContainerNoSidenav.vue?vue&type=script&lang=js"
import style0 from "./DefaultContainerNoSidenav.vue?vue&type=style&index=0&id=bd50bc80&prod&lang=css"
import style1 from "./DefaultContainerNoSidenav.vue?vue&type=style&index=1&id=bd50bc80&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd50bc80",
  null
  
)

export default component.exports